import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Avatar } from "./AppShell";
import { Sheet, Button } from "./ui";
import { Icon } from "./icons";

/** Who is in this conversation (same list as the Mobile app: /chat/:room/members). */
export function ChatMembers({ room, me }) {
  const [open, setOpen] = useState(false);
  const q = useQuery({ queryKey: ["chat-members", room], queryFn: () => api(`/chat/${encodeURIComponent(room)}/members`), staleTime: 60000 });
  const members = [...(q.data || [])].sort((a, b) => (a.name || "").localeCompare(b.name || "", "pt"));
  const n = members.length;
  return (
    <>
      <button className="chip" onClick={() => setOpen(true)} data-testid="chat-members-toggle" aria-label="Ver participantes da conversa" style={{ maxWidth: "100%" }}>
        <Icon name="people" size={14} /> <span data-testid="chat-members-count">{n} {n === 1 ? "PESSOA" : "PESSOAS"}</span>
      </button>
      {open ? (
        <Sheet title={`Participantes · ${n}`} onClose={() => setOpen(false)} testid="chat-members-list">
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {members.map((u) => (
              <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 12 }} data-testid={`chat-member-${u.id}`}>
                <Avatar user={u} size={36} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontFamily: "var(--f-medium)", fontSize: 15 }}>{u.name}{u.id === me?.id ? " (eu)" : ""}</div>
                  <div className="t-hint">{[u.role === "admin" ? "ADMINISTRADOR" : null, u.voice ? u.voice.toUpperCase() : null].filter(Boolean).join(" · ")}</div>
                </div>
              </div>
            ))}
            {!n && !q.isLoading ? <div className="t-hint">Sem participantes.</div> : null}
          </div>
        </Sheet>
      ) : null}
    </>
  );
}

/** Conversation options: clear for me (everyone) and delete the whole history (moderation). */
export function RoomMenu({ room, moderator, onClearMe, onClearAll }) {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const close = () => { setOpen(false); setConfirm(null); };
  return (
    <>
      <button className="icon-btn" onClick={() => setOpen(true)} aria-label="Opções da conversa" data-testid="chat-room-menu"><Icon name="ellipsis" size={20} /></button>
      {open ? (
        <Sheet title={confirm ? confirm.title : "Conversa"} onClose={close} testid="chat-room-sheet">
          {confirm ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div className="t-hint">{confirm.text}</div>
              <div style={{ display: "flex", gap: 8 }}>
                <Button className="ghost" onClick={() => setConfirm(null)} data-testid="chat-room-cancel">CANCELAR</Button>
                <Button onClick={() => { confirm.run(); close(); }} style={confirm.danger ? { background: "var(--error)" } : undefined} data-testid="chat-room-confirm">{confirm.label}</Button>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <button className="card" style={{ padding: 14, textAlign: "left", cursor: "pointer", color: "inherit" }} data-testid="chat-action-clear-me"
                onClick={() => setConfirm({ title: "Limpar a conversa para si?", text: "O histórico deixa de aparecer para si. Os outros membros não são afectados e as novas mensagens continuam a chegar.", label: "LIMPAR PARA MIM", run: onClearMe })}>
                <div style={{ fontFamily: "var(--f-medium)" }}>Limpar conversa (só para mim)</div>
              </button>
              {moderator ? (
                <button className="card" style={{ padding: 14, textAlign: "left", cursor: "pointer", color: "var(--on-error)" }} data-testid="chat-action-clear-room"
                  onClick={() => setConfirm({ title: `Apagar todo o chat ${decodeURIComponent(room)}?`, text: "Todas as mensagens, fotos, áudios e anexos são eliminados para todos os membros. Esta acção não pode ser anulada.", label: "APAGAR TUDO", danger: true, run: onClearAll })}>
                  <div style={{ fontFamily: "var(--f-medium)" }}>Apagar todas as mensagens (moderação)</div>
                </button>
              ) : null}
            </div>
          )}
        </Sheet>
      ) : null}
    </>
  );
}
